export const POLLING_CONFIG = {
  FETCH_DOC_LIST_INTERVAL: 10000,
  FETCH_DOC_DETAILS_INTERVAL: 10000
};
